import React from 'react'
import { URL } from '../../Redux/common/url';

const LoadOptions = async (apiUrl, search, currOptions, { page, value, label, extras = {} }) => {
    const queryParams = new URLSearchParams({ page, search, ...extras });
    console.log("queryParams.toString() ==> ", queryParams.toString());

    const token = await localStorage.getItem("admin_token");
    const url = `${URL.API_BASE_URL}${apiUrl}?${queryParams.toString()}`;
    const response = await fetch(url,
        {
            headers: {
                Authorization: "Bearer " + token,
            },
        }
    );
    const resJSON = await response.json();
    const res = resJSON?.data?.data;
    const options = res?.length > 0 ? res?.map((data) => ({ value: data[value], label: data[label] })) : [];

    const obj = {
        options: options,
        hasMore: resJSON?.data?.total > resJSON?.data?.to ? true : false,
        additional: {
            page: page + 1,
        },
    };
    return obj;
}

export default LoadOptions